var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import MultiSelectFilterOption from "./MultiSelectFilterOption";
import MultiSelectFilterOptGroup from "./MultiSelectFilterOptGroup";
import MultiSelectFilterNoResult from "./MultiSelectFilterNoResult";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
var MultiSelectFilterOptionList = function (_a) {
    var focusPreviousElement = _a.focusPreviousElement, focusNextElement = _a.focusNextElement, focusNextOption = _a.focusNextOption, focusPreviousOption = _a.focusPreviousOption, focusFirstOption = _a.focusFirstOption, focusLastOption = _a.focusLastOption;
    var _b = useMultiSelectFilterContext(), multiSelectModel = _b.multiSelectModel, onChange = _b.onChange;
    var onKeyDown = function (event) {
        switch (event.key) {
            case "Tab":
                if (event.shiftKey) {
                    focusPreviousElement(event);
                }
                else {
                    focusNextElement(event);
                }
                event.preventDefault();
                break;
            case "ArrowDown":
                focusNextOption();
                event.preventDefault();
                break;
            case "ArrowUp":
                focusPreviousOption();
                event.preventDefault();
                break;
            case "Home":
                focusFirstOption();
                event.preventDefault();
                break;
            case "End":
                focusLastOption();
                event.preventDefault();
                break;
            case "a":
                if (event.ctrlKey) {
                    var newValues = multiSelectModel.hasAllFilteredOptionsSelected()
                        ? multiSelectModel.unselectAllFilteredOptions()
                        : multiSelectModel.selectAllFilteredOptions();
                    onChange(newValues, event);
                    event.preventDefault();
                }
        }
    };
    if (multiSelectModel.optionsFiltered.length > 0) {
        return (React.createElement("ul", { className: "ssg-multi-select-filter__options-list", tabIndex: -1, onKeyDown: onKeyDown }, multiSelectModel.optionsFiltered.map(function (option) {
            if ("name" in option && "value" in option) {
                return React.createElement(MultiSelectFilterOption, __assign({ key: option.value }, option));
            }
            else {
                return React.createElement(MultiSelectFilterOptGroup, __assign({ key: option.label }, option));
            }
        })));
    }
    return (React.createElement("ul", { className: "ssg-multi-select-filter__options-list", tabIndex: -1 },
        React.createElement(MultiSelectFilterNoResult, null)));
};
export default MultiSelectFilterOptionList;
